import React from 'react'


const TripCreationComponentLoadable = React.lazy(() => import('./TripCreationComponent'))

export {
	TripCreationComponentLoadable
}